var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.wrapClasss }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "mku-table__body" }, [
      _c(
        "table",
        {
          staticClass: "mku-table__tb",
          attrs: { border: "0", cellspacing: "0", cellpadding: "0" }
        },
        [
          _vm._m(1),
          _vm._v(" "),
          _c(
            "tbody",
            _vm._l(4, function(trItem, trIndex) {
              return _c(
                "tr",
                {
                  key: trIndex,
                  staticClass: "mku-table__tr",
                  class: _vm.tdClasss(trItem, trIndex)
                },
                [_vm._t("default")],
                2
              )
            }),
            0
          )
        ]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mku-table__head" }, [
      _c(
        "table",
        {
          staticClass: "mku-table__tb",
          attrs: { border: "0", cellspacing: "0", cellpadding: "0" }
        },
        [
          _c("colgroup", [
            _c("col"),
            _vm._v(" "),
            _c("col", { attrs: { width: "340" } }),
            _vm._v(" "),
            _c("col", { attrs: { width: "240" } }),
            _vm._v(" "),
            _c("col")
          ]),
          _vm._v(" "),
          _c("thead", [
            _c("tr", [
              _c("th", { staticClass: "mku-table__th" }, [_vm._v("标题")]),
              _vm._v(" "),
              _c("th", { staticClass: "mku-table__th" }, [_vm._v("内容")]),
              _vm._v(" "),
              _c("th", { staticClass: "mku-table__th" }, [_vm._v("简介")]),
              _vm._v(" "),
              _c("th", { staticClass: "mku-table__th" }, [_vm._v("来源")])
            ])
          ])
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("colgroup", [
      _c("col", { attrs: { width: "" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "340" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "240" } }),
      _vm._v(" "),
      _c("col")
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }